import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { Table } from "antd";
import { CommunicationChannelEnum } from "./api/Representation";
import { useAppSelector } from "../../../../store";
import { selectedTenantSelector, selectedTenantSettingsSelector } from "../../../../store/slice/auth";
const ConsignmentCommunicationChannelsTable = ({ consignment }) => {
    const [stateTenantCanSMS, setStateTenantCanSMS] = React.useState(true);
    const [stateTenantCanEmail, setStateTenantCanEmail] = React.useState(true);
    const selectedTenant = useAppSelector(selectedTenantSelector);
    const selectedTenantSettings = useAppSelector(selectedTenantSettingsSelector);
    useEffect(() => {
        setStateFromTenantSettings();
    }, []);
    useEffect(() => {
        setStateFromTenantSettings();
    }, [selectedTenantSettings, consignment, selectedTenant]);
    const setStateFromTenantSettings = () => {
        if (consignment && selectedTenant && selectedTenantSettings && selectedTenantSettings.deliveryNotifications && consignment.tenantId === selectedTenant.id) {
            setStateTenantCanSMS(selectedTenantSettings.deliveryNotifications.sendSMS);
            setStateTenantCanEmail(selectedTenantSettings.deliveryNotifications.sendEmail);
        }
    };
    const renderAvailableChannels = (channels) => {
        const viaEmail = stateTenantCanEmail && (!channels || channels.indexOf(CommunicationChannelEnum.EMAIL) >= 0);
        const viaSMS = stateTenantCanSMS && (!channels || channels.indexOf(CommunicationChannelEnum.SMS) >= 0);
        if (!viaEmail && !viaSMS) {
            return _jsx(_Fragment, { children: "\u2014" });
        }
        let result = '';
        if (viaEmail) {
            result = 'Email';
        }
        if (viaEmail && viaSMS) {
            result += ' and ';
        }
        if (viaSMS) {
            result += 'SMS';
        }
        return result;
    };
    const cols = [
        {
            title: 'Send',
            dataIndex: 'message'
        },
        {
            title: 'Via',
            dataIndex: 'channels',
            render: (text, record) => {
                return renderAvailableChannels(record.channels || []);
            }
        }
    ];
    const data = [
        {
            key: 'SCHEDULED',
            message: 'Scheduled',
            channels: consignment.scheduledCommunicationChannels
        },
        {
            key: 'STARTED',
            message: 'Started',
            channels: consignment.startedCommunicationChannels
        },
        {
            key: 'COMPLETED',
            message: 'Completed',
            channels: consignment.completedCommunicationChannels
        }
    ];
    return (_jsx(Table, { columns: cols, dataSource: data, size: "small", pagination: false }));
};
export default ConsignmentCommunicationChannelsTable;
